
        var result = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./formcontrol-subdocument.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/formcontrol-subdocument/formcontrol-subdocument.component.scss
// module id = 329
// module chunks = 0 1